import theme from '../../base';

const dropdown = {
  background: theme.colors.neutrals.gray800,
  border: theme.colors.neutrals.gray800,
  foreground: theme.colors.neutrals.white,
  itemHover: theme.colors.neutrals.gray700,
  divider: theme.colors.neutrals.gray850,
};

export default dropdown;
